// extracted by mini-css-extract-plugin
export default {"auth":"AuthPage-module__auth___QK5oO"};